import { useMemo } from "react";
import { useSearchParams } from "hooks/search-params/useSearchParams";
import { AlertResponse, useGetAlert } from "hooks/alerts/useGetAlert";

/**
 * Gets the alert id from the search params of the url then fetches it
 * @returns {AlertResponse} a response object containing loading, error and an alert object
 */
export const useGetAlertFromParam = (): AlertResponse => {
  const { searchParams } = useSearchParams();

  const alertId = useMemo(() => {
    let alertIdString = searchParams.get("alert");

    // Note: if a list is provided, it will only parse the first number
    const alertId = alertIdString ? Number.parseInt(alertIdString) : undefined;

    // Only return the number if it is not a NaN
    return !Number.isNaN(alertId) ? alertId : undefined;
  }, [searchParams]);
  const { loading, error, alert } = useGetAlert(alertId);

  return { loading, error, alert };
};
